import axios from "axios";
import { LinkHelper } from "../helpers";
import { boxLabels, monthLabels } from "../product/constants";
import { getApiUrl } from "../core/config/api";
import { symbolFor } from "../core/currency";

export async function downloadLookbook(id, fileId, fileName = null) {
  // Shared axios instance, not a raw fetch() — lookbooks are store-scoped,
  // so this needs the Authorization and X-Active-Store headers
  // (axios.defaults.headers.common) a bare fetch() never carries.
  const response = await axios.get(getApiUrl(`/api/pdfs/${fileId}`), { responseType: "blob" });
  const blob = response.data;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const name = fileName || `LOOKBOOK_S${String(id).padStart(3, "0")}`;
  a.href = url;
  a.download = `${name}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const ucFirst = (string) => {
  return string ? string[0].toUpperCase() + string.substr(1) : string;
};

export function buildListingBroadcastMessage(listing) {
  let message = "";

  const month =
    listing?.month && listing?.month !== "00"
      ? `${monthLabels?.[listing?.month]} `
      : "";

  message += `\nBrand: ${listing?.product?.brand?.name} ${listing?.product?.model?.name}`;
  message += `\nRef: ${listing?.product?.reference_number}`;
  message += `\nCase Material: ${
    listing?.product?.values?.case_material?.value ||
    listing?.values?.case_material ||
    "N/A"
  }`;
  message += `\nCase Size: ${
    listing?.product?.values?.case_diameter?.value ||
    listing?.values?.case_diameter ||
    "N/A"
  }`;
  message += `\nColor: ${
    listing?.product?.values?.dial_color?.value ||
    listing?.values?.dial_color ||
    "N/A"
  }`;
  // TODO(multicurrency): listing.currency once API exposes it here
  const currencySymbol = symbolFor("gbp");
  message += `\n`;
  message += `\n ▪️  ${currencySymbol}${(listing?.price / 100)?.toLocaleString()}  ▪️`;
  message += `\n`;
  message += `\nDate: ${month}${listing?.year}`;
  message += `\nCondition: ${ucFirst(listing?.condition)}`;
  message += `\nSet: ${boxLabels?.[listing?.box]}`;
  message += `\n`;
  message += `\n${
    !listing?.merchant_id
      ? LinkHelper.link(`/product/${listing?.id}`)
      : listing?.shopify_url || ""
  }`;

  return message;
}
